import { Map, fromJS } from 'immutable';


export const initialState = new Map({
  businessName: new Map(),
  email: new Map(),
  location: new Map({ value: {} }),
  locationCount: new Map(),
  name: new Map(),
  password: new Map(),
  phone: new Map(),
  phonecode: new Map(),
  staffCount: new Map(),
  validForm: false,
});


export const signUpInit = ({ signUp }) => fromJS(signUp);


export const signUpSetField = (state, { field, value }) => state.setIn(field, value);


export const signUpValidForm = (state, { value }) => state.set('validForm', value);


export const signUpWorking = (state, { value }) => state.set('working', value);


export const signUpSetToast = (state, { value }) => state.set('toast', fromJS(value));


export const signUpDelToast = state => state.delete('toast');


export const signUpComplete = state => state.set('complete', true);

export function signUpSetPhone(state, { value }) {
  return state.withMutations((mutState) => {
    mutState.setIn(['phonecode', 'value'], `${value.country}: +${value.code}`);
    mutState.setIn(['phone', 'value'], value.phone);
    return mutState;
  });
}



// WEBPACK FOOTER //
// ./src/store/signUp/core.js